import { Component, OnInit } from '@angular/core';
import { Router, Route, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../providers/login.service';
import { FormControl, Validators } from '@angular/forms';
import { createSession } from '../../common/sessionHandler';
import { ApiPromisefactory } from '../../providers/promise.factory';
import { MethodSummary } from '../../models/methodSummary';
import { Params } from '../../models/params';
import { MethodServiceJava } from '../../providers/methodsService.java';
import { MethodServiceSwift } from '../../providers/methodsService.swift';
import { MatDialog } from '@angular/material/dialog';
import '../../prism/prism.js'
import { LanguageSettings } from '../../providers/languageSettings.service';
declare var Prism;

@Component({
  selector: 'app-getstartedmoduleqr',
  templateUrl: './getstartedmoduleqr.html',
  styleUrls: ['../bleclassmodule/bleclassmodule.css']
})


export class GetStartedComponentQR{
  selected = 'Java';
  videoPlayer: HTMLVideoElement;

  SwiftImplementationPrism:string;
  JavaScriptImplementationPrism:string;
  JavaImplementationPrism:string;
  JavaImplementation:string = "\n\
  implementation project(':sgconnectapi')\n\
  ";

  JavaDependenciesPrism: string;
  JavaScriptDependenciesPrism: string;
  SwiftDependenciesPrism: string;
  SwiftDependencies = '\n\
  <key>UIRequiredDeviceCapabilities</key>\n\
  <array>\n\
    <string>bluetooth-le</string>\n\
  </array>\n\
  <key>NSBluetoothPeripheralUsageDescription</key>\n\
  <string>Allow application to communicate with the gaming machine.</string>\n\
  <key>UIBackgroundModes</key>\n\
  <array>\n\
    <string>bluetooth-central</string>\n\
  </array>';

  JavaScriptiOSDependenciesPrism: string;
  JavaScriptiOSDependencies = '<preference name="deployment-target" value="10" />';

  JavaDependencies = "\n\
  dependencies {\n\
  \timplementation ('com.google.android.gms:play-services-vision:10.2.6'){\n\
      transitive = true;\n\
  \t}\n\
  \timplementation ('com.android.volley:volley:1.1.1'){\n\
    transitive = true;\n\
  \t}\n\
  }"


  constructor(
      public router: Router,
      public dialog: MatDialog,
      private languageSettings: LanguageSettings) {

  }


  onLanguageChanged(lang){
    this.selected = lang;
    if (this.videoPlayer) {
      this.videoPlayer.load();
    }
  }

  ngOnInit() {
    this.applyPrism();
    this.selected = this.languageSettings.getSelectedLanguage();
    this.languageSettings.getLanguageChangeEmitter().subscribe(
      item => this.onLanguageChanged(item)
    );
  }

  ngAfterViewInit() {
    this.applyPrism();
  }

  onSkip() {
    this.videoPlayer.currentTime = 50;
  }

  applyPrism() {
    this.JavaImplementationPrism = this.JavaScriptImplementationPrism = this.SwiftImplementationPrism = Prism.highlight(this.JavaImplementation, Prism.languages.java);
    this.JavaDependenciesPrism = this.JavaScriptDependenciesPrism = Prism.highlight(this.JavaDependencies, Prism.languages.java);
    this.SwiftDependenciesPrism = Prism.highlight(this.SwiftDependencies, Prism.languages.markup);

  }

  goBleExamplePage() {
    this.router.navigate(['/sgconnect/example-SGCardlessConnect']);
  }

  goQrExamplePage() {
    this.router.navigate(['/sgconnect/example-SGQRConnect']);
  }
}
